import { render, staticRenderFns } from "./loginCompModal.vue?vue&type=template&id=1145e64a&scoped=true&"
import script from "./loginCompModal.vue?vue&type=script&lang=js&"
export * from "./loginCompModal.vue?vue&type=script&lang=js&"
import style0 from "./loginCompModal.vue?vue&type=style&index=0&id=1145e64a&lang=scss&scoped=true&"
import style1 from "./loginCompModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1145e64a",
  null
  
)

export default component.exports